export const PromoChange = (value) => {
    return (dispatch) => {
        return dispatch({ type: 'PROMOÇÃO', payload: value}) 
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/modal.js